import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", href: "#top" },
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    if (href === "#contact") return window.__openEnquiry();
    if (href === "#top") return window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.2 }) : window.scrollTo({ top: 0, behavior: "smooth" });
    if (window.__scrollToId) window.__scrollToId(href);
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => go("#top")} className="font-display text-lg tracking-[0.15em]">
          ETIA MEDIA
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#8A8A85] hover:text-[#F2F0EB] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-call-btn"
            onClick={() => go("#contact")}
            className="bg-[#F2F0EB] text-[#0A0A0A] font-display text-xs tracking-[0.1em] px-6 py-3 rounded-full hover:scale-105 transition-transform duration-300"
          >
            Book a Call
          </button>
        </nav>

        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="md:hidden text-[#F2F0EB]">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-drawer"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[#0A0A0A]/95 backdrop-blur-xl border-b border-white/10 overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <button
                  key={l.label}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  onClick={() => go(l.href)}
                  className="text-left font-mono2 text-xs uppercase tracking-[0.25em] text-[#8A8A85]"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-book-call-btn"
                onClick={() => go("#contact")}
                className="bg-[#F2F0EB] text-[#0A0A0A] font-display text-xs tracking-[0.1em] px-6 py-3 rounded-full w-fit"
              >
                Book a Call
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
